import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-feature client state — the Notes list's UI preferences.
 *
 * Persisted narrowly (CLAUDE.md §2.3): only the view mode is durable. Search +
 * pinned filter are ephemeral session state and stay out of `partialize`, so a
 * page reload returns the user to "show everything" — a sensible default.
 */
export type NotesViewMode = 'cards' | 'list' | 'table' | 'grouped';

export const NOTES_VIEW_MODES: NotesViewMode[] = ['cards', 'list', 'table', 'grouped'];

interface NotesUiState {
  view: NotesViewMode;
  search: string;
  pinnedOnly: boolean;

  setView: (view: NotesViewMode) => void;
  setSearch: (search: string) => void;
  setPinnedOnly: (pinnedOnly: boolean) => void;
}

export const useNotesUi = create<NotesUiState>()(
  persist(
    (set) => ({
      view: 'cards',
      search: '',
      pinnedOnly: false,
      setView: (view) => set({ view }),
      setSearch: (search) => set({ search }),
      setPinnedOnly: (pinnedOnly) => set({ pinnedOnly }),
    }),
    {
      name: 'notes:ui',
      // Persist only the durable preference — search + filter are session-only.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
